import { Component, effect, Input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import * as fromUnits from 'app/state/units';
import * as fromBeverage from 'app/state/beverage';
import * as dateHelper from 'app/helpers/date.helpers';
import { IBeverage } from 'app/models/beverage';
import { IBottle } from 'app/models/bottle';
import { Store } from '@ngrx/store';
import { IonicModule } from '@ionic/angular';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-bottle',
  templateUrl: './bottle.component.html',
  styleUrls: ['./bottle.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    RouterModule
]

})
export class BottleComponent implements OnChanges {


  unitTypes = this.store.selectSignal(fromUnits.getUnits);
  beverages = this.store.selectSignal(fromBeverage.selectAllEntities);
  @Input() bottle: IBottle | undefined;
  @Input() searchPhrase!: string;

  dateHelper = dateHelper;
  today = new Date();

  display = signal(true);

  beverage: IBeverage | undefined = undefined;

  constructor(private store: Store) {
    effect(() => {
      const beverageEntites = this.beverages();
      if (beverageEntites && this.bottle) {
        this.beverage = beverageEntites[this.bottle.beverageId];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.bottle && this.beverage) {
      if (this.searchPhrase) {
        this.display.set(this.beverage.name.toLowerCase().includes(this.searchPhrase.toLowerCase()));
      } else {
        this.display.set(true);
      }
    }

  }

}
